import { ScreenUtil } from '@/modules/common/utils/screen.util.ts';
import { Breakpoints } from '@/modules/common/consts/breakpoints.const.ts';

export class PageSizeUtil {
  static calc(height = ScreenUtil.getScreenHeight()) {
    if (height > Breakpoints.height.xxl) {
      return 100;
    } else if (height > Breakpoints.height.xl) {
      return 75;
    } else {
      return 50;
    }
  }
}
